module.exports = __webpack_public_path__ + "img/baozhangzhong.85d0611c.png";